import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import AppRouter from "@/AppRouter";
import AppErrorBoundary from "@/components/AppErrorBoundary";
import { AuthProvider } from "@/auth/AuthContext";
import { AuthorizationProvider } from "@/auth/AuthorizationContext";
import { installAxiosCsrfInterceptor } from "@/auth/csrfClient";
import { migrateLegacyAuthStorage } from "@/auth/authStorage";
import { applyFontScale, getFontScale } from "@/utils/fontScale";

// Yazı boyutu tercihi React mount'tan ÖNCE uygulanır ki ilk çizimde
// "önce küçük, sonra büyük" sıçraması olmasın.
applyFontScale(getFontScale());

// "ResizeObserver loop ..." — tarayıcının zararsız bir uyarısıdır (Radix Popover/
// Command gibi bileşenler sürüklenebilir modal içinde konum hesaplarken tetikler).
// Gerçek bir hata değildir; CRA dev overlay'inin bunu kırmızı hata gibi göstermesini
// engelliyoruz. Production'da overlay zaten yok, bu kod no-op.
const _silenceResizeObserverError = (e) => {
  const msg = e?.message || "";
  if (msg.indexOf("ResizeObserver loop") !== -1) {
    e.stopImmediatePropagation();
    const overlay = document.getElementById("webpack-dev-server-client-overlay");
    const overlayDiv = document.getElementById("webpack-dev-server-client-overlay-div");
    if (overlay) overlay.style.display = "none";
    if (overlayDiv) overlayDiv.style.display = "none";
  }
};
window.addEventListener("error", _silenceResizeObserverError);

// Cookie tabanlı auth: tüm axios isteklerine credentials + CSRF header
installAxiosCsrfInterceptor();
// Eski sessionStorage/localStorage'daki token alanlarını temizle
migrateLegacyAuthStorage();

const root = ReactDOM.createRoot(document.getElementById("root"));
// Not: Dev ortamında bazı üçüncü parti bileşenler StrictMode'un çift mount/unmount
// davranışında DOM removeChild hatasına düşebiliyor. Bu yüzden development'ta
// StrictMode sarmalayıcısını kapatıyoruz.
//
// AuthorizationProvider — Sprint 2 frontend uygulaması. AuthProvider içinden
// (login durumunu okur), permission + chain bilgisini context'e ekler.
// Tüm component'ler useAuthorization() ile aynı cache'ten okur.
if (process.env.NODE_ENV === "development") {
  root.render(
    <AppErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <AuthorizationProvider>
            <AppRouter />
          </AuthorizationProvider>
        </AuthProvider>
      </BrowserRouter>
    </AppErrorBoundary>,
  );
} else {
  root.render(
    <React.StrictMode>
      <AppErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <AuthorizationProvider>
              <AppRouter />
            </AuthorizationProvider>
          </AuthProvider>
        </BrowserRouter>
      </AppErrorBoundary>
    </React.StrictMode>,
  );
}
